export class Animation {
  public fadeOut(el) {
  el.style.opacity = 1;

  (function fade() {
    if ((el.style.opacity -= .1) < 0) {
      el.style.display = 'none !important';
      el.classList.add('is-hidden');
    } else {
      requestAnimationFrame(fade);
    }
  })();
}

// fade in

  public fadeIn(el, display) {
  if (el.classList.contains('is-hidden')) {
    el.classList.remove('is-hidden');
  }
  el.style.opacity = 0;
  el.style.display = display || 'block';

  (function fade() {
    let val = parseFloat(el.style.opacity);
    if (!((val += .1) > 1)) {
      el.style.opacity = val;
      requestAnimationFrame(fade);
    }
  })();
}
  public fadeToggle(el) {
    if ( el.classList.contains('is-hidden')) {
      this.fadeIn(el, 'block');
    } else {
      this.fadeOut(el);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/library/Animation.ts